/** Single source of truth for visible FAQ copy and FAQPage JSON-LD. */
export const LANDING_FAQ: { q: string; a: string }[] = [
  {
    q: "What markets do you cover?",
    a: "Bastion covers 4,000+ stocks across the US, Europe, Asia, and selected developed and emerging markets. Coverage varies by market and company size.",
  },
  {
    q: "How are Bastion ratings calculated?",
    a: "Each strategy rating ranks a stock from 0 to 100 against the relevant stock universe. Ratings combine selected fundamental, valuation, quality, growth, and momentum metrics. A high rating means a stronger fit for that strategy, not a prediction or recommendation.",
  },
  {
    q: "How do you source and update the data?",
    a: "Bastion uses licensed company fundamentals, market data, and analyst consensus estimates from third-party data providers. We calculate proprietary metrics, scores, and rankings on top of that data. Ratings and rankings are recalculated daily, although the timing of underlying source data varies by provider and metric.",
  },
  {
    q: "Where do company forecasts come from, and how should I interpret them?",
    a: "Forecast metrics use sell-side analyst consensus estimates supplied by our data provider. Bastion uses them as inputs to valuation and scoring. They represent current market expectations, not Bastion predictions or guaranteed outcomes.",
  },
  {
    q: "How often are portfolios updated?",
    a: "Bastion has 13 equal-weighted systematic model portfolios. They are rebalanced monthly using the latest strategy ratings, with changes calculated on the last trading day of the month.",
  },
  {
    q: "What do the portfolio results represent?",
    a: "Portfolio results are calculated from model portfolios tracked live since June 2024. They do not represent client accounts and exclude commissions, bid-ask spreads, taxes, and other transaction costs. Past performance does not guarantee future results.",
  },
  {
    q: "Can I try Bastion before subscribing?",
    a: "Yes. The free Basic plan includes key ratings and a Growth preview on any covered stock, Radar and Heatmap access for core free lists, and one watchlist for up to five stocks. Premium costs $29 per month or $249 per year and unlocks full Stock Verdict depth, all Radar and Heatmap lists, all 13 model portfolios, and expanded watchlists.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes. You can cancel through your account or the Stripe customer portal. Premium access remains active until the end of the paid billing period. No partial refunds are issued for unused time.",
  },
  {
    q: "Does Investment Bastion provide investment advice or recommendations?",
    a: "No. Investment Bastion is an informational and analytical service. We provide financial data, systematic scores, and research tools, but we do not provide personalised recommendations, manage money, or execute trades. You remain responsible for your own investment decisions.",
  },
];

export function landingFaqJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: LANDING_FAQ.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
}
